import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import {
  RequestForMaterial,
  RFMINFOlineItemInfo,
} from "../../../SchemaInfo/info";
import { getId, toTitleCase } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { RFMSchema } from "../../../Schemas/purchase/req_for_material";
import { useNavigate, useParams } from "react-router-dom";
import { FcInTransit } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
// import CustomCheckbox from "../../../CustomComponent/custom_checkbox";

const EditRequestForMaterial = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [materialdata, setmaterialData] = useState([]);
  const { id } = useParams();
  const [data, setData] = useState(RequestForMaterial);

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getAllMaterialList")
      .then((res) => {
        if (res.status === 200) {
          setmaterialData(res.data?.MaterialList);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/rfm/getRFMById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting RFM!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });

    values = {
      ...values,
      generatedBy: userData.Name,
    };

    setLoading(true);
    performRequest("PATCH", `/rfm/updateRFM/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "RFM updated successfully!");

          navigate(`/view-req-for-material/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const checkTouched = (obj) => {
    if (
      obj.deliveryDate === "" &&
      obj.gstRate === "" &&
      obj.itemPrice === "" &&
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.notes === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1"><FcInTransit></FcInTransit>Request For Material</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Request For Material</h2>
            </div>

            <Formik
              initialValues={data}
              validationSchema={RFMSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Usage Purpose
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="purposeUse">
                          <option value="">Usage Purpose</option>
                          <option value="office">Office</option>
                          <option value="inventory">Inventory</option>
                          <option value="clientProject">Client Project</option>
                        </CustomSelect>

                        {props.touched.purposeUse &&
                          props.errors.purposeUse && (
                            <p className="text-danger">
                              {props.errors.purposeUse}
                            </p>
                          )}
                      </div>
                    </div>
                    {props?.values?.purposeUse === "clientProject" && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Project
                        </label>
                        <div className="w-100 col">
                          <CustomSelect type="text" name="project">
                            <option value="">Select</option>
                            {projects &&
                              projects?.map((pro) => {
                                return (
                                  <option
                                    key={pro.cpNumber}
                                    value={getId(pro.cpNumber)}
                                  >
                                    {pro.clientName}
                                  </option>
                                );
                              })}
                          </CustomSelect>

                          {props.touched.project && props.errors.project && (
                            <p className="text-danger">
                              {props.errors.project}
                            </p>
                          )}
                        </div>
                      </div>
                    )}

<div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        <CustomTextArea type="text" name="notes" />

                        {props.touched.notes && props.errors.notes && (
                          <p className="text-danger">{props.errors.notes}</p>
                        )}
                      </div>
                    </div>

                    <hr />
                    <h3>Line Items :</h3>
                    <hr />
                    <FieldArray name="lineItems">
                      {({ push, remove }) => (
                        <div>
                          {props.values.lineItems.map((lineItem, index) => (
                            <div key={index}>
                              <div className="row g-3 align-items-center">
                                {props?.values?.lineItems?.[index]?.itemFrom !==
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label">
                                      Particulars:
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                      />
                                    </div>
                                  </div>
                                )}
                                {props?.values?.lineItems?.[index]?.itemFrom ===
                                  "inventory" && (
                                  <div className="col-md">
                                    <label className=" form-label ">
                                      Particulars
                                    </label>

                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name={`lineItems[${index}].particulars`}
                                        value={
                                          props?.values?.lineItems?.[index]?.id
                                        }
                                        onChange={(e) => {
                                          let item = materialdata?.find(
                                            (el) => el.id == e.target.value
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].particulars`,
                                            item?.item
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].id`,
                                            item?.id
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].hsn`,
                                            item?.hsn
                                          );
                                          props.setFieldValue(
                                            `lineItems[${index}].itemUnit`,
                                            item?.unit
                                          );
                                          //   props.setFieldValue(
                                          //     `lineItems[${index}].itemPrice`,
                                          //     item?.cost
                                          //   );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {materialdata?.map((el) => {
                                          return (
                                            <option key={el.id} value={el?.id}>
                                              {el?.item}
                                            </option>
                                          );
                                        })}
                                      </CustomSelect>
                                    </div>
                                  </div>
                                )}

                                <div className="col-md">
                                  <label className=" form-label ">
                                    Item units
                                  </label>

                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="text"
                                      name={`lineItems[${index}].itemUnit`}
                                    >
                                      <option value="">Select</option>
                                      <option value="nos">Nos</option>
                                      <option value="kg">Kg</option>
                                      <option value="grams">Grams</option>
                                      <option value="ltr">Litter</option>
                                      <option value="ml">ML</option>
                                      <option value="packs">Packs</option>
                                      <option value="pair">Pair</option>
                                      <option value="sqm">SqM</option>
                                      <option value="sqft">SqFt</option>
                                      <option value="mts">Meters</option>
                                      <option value="pcs">Pices</option>
                                    </CustomSelect>
                                  </div>
                                </div>
                                <div className="col-md">
                                  <label className=" form-label ">
                                    Quantity
                                  </label>
                                  <div className="w-100 col">
                                    <CustomInput
                                      type={"text"}
                                      name={`lineItems[${index}].itemQuantity`}
                                    />
                                  </div>
                                </div>

                                <div className="col-md">
                                  <button
                                    className="col-3 btn btn-primary"
                                    style={{
                                      width: "70px",
                                      height: "30px",
                                    }}
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                          <button
                            className="btn btn-primary mt-2 me-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...RFMINFOlineItemInfo,
                                  itemFrom: "inventory",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...RFMINFOlineItemInfo,
                                  itemFrom: "inventory",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Inventory Item
                          </button>
                          <button
                            className="btn btn-primary mt-2"
                            type="button"
                            onClick={() => {
                              if (props.values.lineItems.length === 0) {
                                push({
                                  ...RFMINFOlineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else if (
                                props.values.lineItems.length > 0 &&
                                checkTouched(
                                  props.values.lineItems[
                                    props.values.lineItems.length - 1
                                  ]
                                )
                              ) {
                                push({
                                  ...RFMINFOlineItemInfo,
                                  itemFrom: "custom",
                                });
                              } else {
                                Toast(
                                  "error",
                                  "Please fill at least one line item field."
                                );
                              }
                            }}
                          >
                            Add Custom Line Item
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Update RFM" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditRequestForMaterial;
